module.exports = __webpack_public_path__ + "static/media/twitter.2210c4de.2210c4de.svg";